import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import FS from "../assets/Solar-Panel.webp";
import GS from "../assets/Solar-Penal.webp";
import Team from "../assets/team.png";
import ParticleBackground from "../components/ParticleBackground";
import StatCounter from "../components/StatsCounter";
import { Link } from "react-router-dom";

const FreeSolarPanel = () => {
  const [cardsPerRow, setCardsPerRow] = useState(3);

  const updateCardsPerRow = () => {
    const width = window.innerWidth;
    if (width <= 600) {
      setCardsPerRow(1);
    } else if (width <= 992) {
      setCardsPerRow(2);
    } else {
      setCardsPerRow(3);
    }
  };

  useEffect(() => {
    updateCardsPerRow();
    window.addEventListener("resize", updateCardsPerRow);

    AOS.init({
      duration: 800,
      offset: 300,
      once: false,
    });

    return () => {
      window.removeEventListener("resize", updateCardsPerRow);
    };
  }, []);

  useEffect(() => {
    AOS.refresh();
  }, [cardsPerRow]);

  return (
    <>
      <div className="banner">
        <ParticleBackground />

        <div className="banner-content">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-md-12">
                <h1 className="font-48">Hunarmand Solar Reward</h1>
                <p className="font-18 light-grey l-h-1 weight-400">
                  The Solar Panel Reward is one of the performance-based rewards
                  available under the Hunarmand Punjab Scholarship Card.
                  Students who achieve the required merit level, as determined
                  by the Program Management, may become eligible to receive a
                  Free Solar Panel to support their continued learning,
                  practical training, freelancing, and professional development.
                </p>
              </div>
              <div className="col-lg-4 col-md-12">
                <img
                  src="/images/Solar Scheme.jpg"
                  alt="Course"
                  className="w-100 banner-image"
                />
                <div className="cube"> </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container pt-5">
        <div className="row pt-5 pb-5  ">
          <div className="col-lg-6" data-aos="fade-right">
            <img
              className="w-100"
              src="/images/Solar Scheme Page Image (2).jpeg"
              alt=""
            />
          </div>
          <div className="col-lg-6" data-aos="fade-left">
            <h2 className="fw-semibold">
              Your Digital Future Starts Here - Performance-Based Solar Panel Reward
            </h2>
            <div>
              <p className="card-text text-muted">
                The Hunarmand Punjab Scholarship Card is awarded strictly on merit and recognizes students who
                demonstrate exceptional academic performance throughout the program. Scholarship rewards begin
                from a minimum score of 80% in the Final Evaluation Test.
              </p>
              <p className="card-text text-muted">
                The Solar Panel Reward is one of the performance-based rewards available under the Hunarmand Punjab
                Scholarship Card. Students who achieve the required merit level, as determined by the Program
                Management, may become eligible to receive a Free Solar Panel to support their continued
                learning, practical training, freelancing, and professional development.
              </p>
              <div className="mt-4">
                <p className="fw-semibold text-success">
                  ⚡ Merit-Based Scholarship Rewards:
                </p>
                <ul className="mt-2 list-unstyled">
                  <li><strong>80% - 82% Merit:</strong> Fee Refund</li>
                  <li><strong>83% - 84% Merit:</strong> Chromebook Reward</li>
                  <li><strong>85% - 89% Merit:</strong> Laptop Reward</li>
                  <li><strong>90% + Merit:</strong> E-Bike Reward</li>
                </ul>
              </div>
              <p className="mt-3" style={{ fontSize: "14px", opacity: 0.9 }}>
                The exact percentage thresholds, reward quotas, eligibility criteria, and distribution process for each
                reward are determined solely by Hunarmand Punjab and may be revised from time to time.
              </p>
              <p className="mt-2" style={{ fontSize: "14px", opacity: 0.9 }}>
                <strong>Important:</strong> Achieving 80% marks qualifies a student to be considered for the Scholarship Reward
                Program. Rewards are allocated according to the student's final merit ranking, approved criteria,
                available quota, and the policies of Hunarmand Punjab.
              </p>
              <div className="mt-4">
                <Link
                  to="/apply-scholarshipcard"
                  className="btn-green register-btn btn btn-success"
                >
                  Apply Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <StatCounter />
    </>
  );
};

export default FreeSolarPanel;
